export default "__VITE_ASSET__ukWl8$X9__"